import { render, staticRenderFns } from "./DlsglList.vue?vue&type=template&id=5c95f0e8"
import script from "./DlsglList.vue?vue&type=script&lang=js"
export * from "./DlsglList.vue?vue&type=script&lang=js"
import style0 from "./DlsglList.vue?vue&type=style&index=0&id=5c95f0e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports